export default __webpack_public_path__ + "static/media/marke_3.25f00925.png";